import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { get, post, patch, del } from '../lib/apiClient';

export interface SenderIdentity {
  id: string;
  from_name: string;
  from_email: string;
  reply_to_email: string | null;
  title: string | null;
  is_default: boolean;
  is_connected: boolean;
  is_active: boolean;
  spf_verified: boolean;
  dkim_verified: boolean;
  dmarc_verified: boolean;
  created_at: string | null;
}

export interface SenderIdentityPayload {
  from_name: string;
  from_email: string;
  reply_to_email?: string | null;
  title?: string | null;
  is_default?: boolean;
}

export function useSenderIdentitiesQuery(enabled = true) {
  return useQuery({
    queryKey: ['sender-identities'],
    queryFn: () => get<SenderIdentity[]>('settings/sender-identities'),
    enabled,
  });
}

export function useCreateSenderIdentityMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: SenderIdentityPayload) =>
      post<SenderIdentity>('settings/sender-identities', data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['sender-identities'] });
    },
  });
}

export function useUpdateSenderIdentityMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: Partial<SenderIdentityPayload> }) =>
      patch<SenderIdentity>(`settings/sender-identities/${id}`, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['sender-identities'] });
    },
  });
}

export function useDeleteSenderIdentityMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => del(`settings/sender-identities/${id}`),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['sender-identities'] });
    },
  });
}
